import { useState } from "react";
import { isAfter, parseISO, differenceInSeconds } from "date-fns";
import { useInterval } from "../../utils/useIntervals";

export default function useShotClockTimer(loadLocked, expirationTime) {
  const [timeRemaining, setTimeRemaining] = useState("");
  const currentTime = new Date().toISOString();

  useInterval(() => {
    if (loadLocked && isAfter(parseISO(expirationTime), parseISO(currentTime))) {
      let now = new Date().toISOString();
      let diff = differenceInSeconds(parseISO(expirationTime), parseISO(now));
      diff >= 1
        ? setTimeRemaining(new Date(diff * 1000).toISOString().substr(14, 5))
        : setTimeRemaining("");
    } else if (
      (loadLocked &&
        !isAfter(parseISO(expirationTime), parseISO(currentTime))) ||
      !loadLocked
    ) {
      setTimeRemaining("");
    }
  }, 1000);

  return { timeRemaining };
}